var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentModalBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 217,
    viewBox: "0 0 226 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.2854,
    cy: 69.1008,
    r: 20.5074,
    stroke: "#FB7C51",
    strokeWidth: 1.67407
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.3444,
    cy: 195.493,
    r: 20.5074,
    stroke: "#FB7C51",
    strokeWidth: 1.67407
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.907,
    cy: 195.493,
    r: 20.5074,
    stroke: "#FB7C51",
    strokeWidth: 1.67407
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.655,
    cy: 195.493,
    r: 20.5074,
    stroke: "#FB7C51",
    strokeWidth: 1.67407
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.041,
    cy: 21.3444,
    r: 20.5074,
    stroke: "#FB7C51",
    strokeWidth: 1.67407
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1528 90.3755V125.446",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2256 173.786C17.2256 166.94 18.056 159.612 17.1203 152.828C16.6074 149.11 14.9798 144.665 19.7532 143.455C26.291 141.798 33.0427 141.926 39.6844 141.085C50.4612 139.721 61.3874 139.424 72.201 138.347C98.8187 135.696 125.364 135.398 152.084 135.398C159.263 135.398 166.442 135.398 173.621 135.398C175.263 135.398 178.23 134.814 179.782 135.504C181.106 136.092 181.838 137.535 182.415 138.795C184.623 143.612 185.939 148.999 186.523 154.25C186.907 157.711 187.568 161.686 188.603 165.019C189.131 166.72 189.735 167.706 189.735 169.521C189.735 171.176 190.563 175.16 188.313 174.26",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.111 138.716C101.111 147.476 101.585 156.238 101.585 165.019C101.585 167.499 103.007 169.493 103.007 171.891",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8833 127.342C75.0338 124.999 76.9966 131.163 82.6272 132.45C84.0387 132.772 86.3503 127.545 87.0505 126.394C88.5371 123.949 89.6858 121.264 91.1578 118.811",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16846 167.151C10.0508 168.034 16.9663 176.082 17.6991 175.471C18.4769 174.823 18.3532 173.012 18.9103 172.128C19.8084 170.701 20.5321 169.433 21.9645 168.573",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9492 171.891C96.9758 171.536 98.2585 171.672 99.3199 173.312C99.5631 173.688 101.764 174.734 102.295 174.734C103.983 174.734 104.546 173.017 105.349 171.627C106.452 169.719 108.693 166.997 108.693 164.782",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.204 170.469C185.181 169.711 186.786 171.132 189.287 174.05C190.343 175.282 191.815 171.627 192.104 170.653C192.958 167.77 195.895 166.038 195.895 162.886",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0921 52.4613C64.2069 47.4451 59.1427 42.4566 55.2976 39.2967C53.0753 37.4704 49.9938 36.4152 48.0308 34.4521",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.135 41.0871C46.0653 40.8082 42.8304 31.4858 44.4499 30.766C45.6027 30.2536 49.0236 31.6238 50.0054 31.8982C52.8969 32.7061 55.7843 33.5896 58.4571 34.926",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4229 50.5658C97.9425 47.8238 99.5036 45.2236 102.479 42.825C105.044 40.7572 107.73 38.9292 110.588 37.2959",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.797 35.4002C109.225 35.4002 117.456 34.358 112.695 38.1385C110.956 39.5194 109.508 40.9445 108.693 42.983",
    stroke: "#FB7C51",
    strokeWidth: 2.51111,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentModalBg);
export default __webpack_public_path__ + "static/media/departmentModalBg.2041185f42715bc35cf1175b10e429e9.svg";
export { ForwardRef as ReactComponent };